export function FbLikeIcon({
  width,
  height,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_1014_110842)">
        <path
          d="M7 1.5C5.4087 1.5 3.88258 2.13214 2.75736 3.25736C1.63214 4.38258 1 5.9087 1 7.5C1 9.09128 1.63214 10.6175 2.75736 11.7427C3.88258 12.8678 5.4087 13.5 7 13.5C8.59128 13.5 10.1175 12.8678 11.2427 11.7427C12.3678 10.6175 13 9.09128 13 7.5C13 5.9087 12.3678 4.38258 11.2427 3.25736C10.1175 2.13214 8.59128 1.5 7 1.5Z"
          fill="url(#paint0_linear_1014_110842)"
        />
        <path
          d="M10.1215 7.0035C10.2535 7.09575 10.375 7.18725 10.375 7.509C10.375 7.8315 10.2032 7.962 10.0195 8.05275C10.0946 8.17521 10.1186 8.32228 10.0862 8.46225C10.0285 8.72025 9.79225 8.9205 9.58225 8.97975C9.673 9.12525 9.7015 9.2685 9.5935 9.44475C9.45475 9.666 9.334 9.75 8.8 9.75H6.625C5.884 9.75 5.5 9.3405 5.5 9V7.24875C5.5 6.32625 6.60025 5.5425 6.60025 4.90125L6.52075 4.1025C6.517 4.05375 6.52675 3.9345 6.56425 3.9C6.62425 3.84075 6.79 3.75 7.0405 3.75C7.204 3.75 7.31275 3.78075 7.441 3.84225C7.87675 4.05 7.99 4.57575 7.99 4.99875C7.99 5.202 7.6795 5.811 7.6375 6.02175C7.6375 6.02175 8.28775 5.87775 9.04675 5.8725C9.8425 5.868 10.3585 6.015 10.3585 6.504C10.3585 6.69975 10.1942 6.89625 10.1215 7.0035ZM3.7 6.75H4.3C4.41935 6.75 4.53381 6.79741 4.6182 6.8818C4.70259 6.96619 4.75 7.08065 4.75 7.2V10.05C4.75 10.1693 4.70259 10.2838 4.6182 10.3682C4.53381 10.4526 4.41935 10.5 4.3 10.5H3.7C3.58065 10.5 3.4662 10.4526 3.38181 10.3682C3.29741 10.2838 3.25 10.1693 3.25 10.05V7.2C3.25 7.08065 3.29741 6.96619 3.38181 6.8818C3.4662 6.79741 3.58065 6.75 3.7 6.75Z"
          fill="white"
        />
      </g>
      <rect x="0.5" y="1" width="13" height="13" rx="6.5" stroke="white" />
      <defs>
        <linearGradient
          id="paint0_linear_1014_110842"
          x1="7"
          y1="1.5"
          x2="7"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#18AFFF" />
          <stop offset="1" stop-color="#0062DF" />
        </linearGradient>
        <clipPath id="clip0_1014_110842">
          <rect x="1" y="1.5" width="12" height="12" rx="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
